module.exports = __webpack_public_path__ + "img/1497082004.c2193680.jpg";